const imgSize = ({width, margin}) => `
    max-width:  ${width || '200px'};
    margin: ${margin || '0'};
`;
const imgSetup = () => `
    margin: 0;
    padding-bottom: 0;
    display: block;
    margin-left: auto;
    margin-right: auto;
`;

export {imgSize, imgSetup};
